import { Grid, SxProps, Typography } from '@mui/material';
import React from 'react';

export interface RowProps {
  value?: string | JSX.Element;
  bold?: boolean;
  mobile?: boolean;
  sx?: SxProps;
  center?: boolean;
}

export const RootineTableRow = (props: RowProps): JSX.Element => {
  return (
    <Grid item xs={12}>
      {typeof props.value === 'string' ? (
        <Typography
          variant={props.bold ? 'bold' : 'inherit'}
          fontSize={16}
          paddingLeft={props.mobile ? {} : 1}
          sx={props.sx ? props.sx : {}}
        >
          {props.value}
        </Typography>
      ) : (
        props.value
      )}
    </Grid>
  );
};
